export enum ISignType {
  Request = 'Request',
  Contract = 'Contract',
  // Документ "Конструктора учредительных документов" (см. КОНСТРУКТОР_РЕСТЫ.md,
  // раздел 5.1) — подписывается вне сущности contract/request, отдельным
  // POST /v1/constructor/sign (см. NCAService.signConstructorDocument).
  Constructor = 'Constructor'
}

export interface IState {
  color: string;
  text: string;
}
export interface IUser {
  iin: string;
  last: string;
  first: string;
  middle: string;
  fullName: string;
  isLegal: boolean;
  bin: string;
  org: {
    bin: string;
    ru: string;
    kk: string;
  };
}
